import styled from "styled-components/native";

type Props = {
  center?: boolean;
};

export const ExtraLargeText = styled.Text<Props>`
  font-size: 30px;
  font-weight: 600;
  padding-bottom: 18px;
  text-align: ${props => (props.center ? "center" : "left")};
  font-family: "Open Sans";
`;
